import { render, staticRenderFns } from "./ElectronicaCategoria.vue?vue&type=template&id=25558a8a&scoped=true"
import script from "./ElectronicaCategoria.vue?vue&type=script&lang=js"
export * from "./ElectronicaCategoria.vue?vue&type=script&lang=js"
import style0 from "./ElectronicaCategoria.vue?vue&type=style&index=0&id=25558a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25558a8a",
  null
  
)

export default component.exports